import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface ForgotPasswordOTPCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(): object;
    getTitleCSSStyle(): object;
    getMobileNumberCSSStyle(): object;
    getRequestOTPButtonCSSStyle(): object;
    
}
export class ForgotPasswordOTPCSSStyleImpl extends UIComponentCSSStyleImpl implements ForgotPasswordOTPCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            borderRadius: "4px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "1px solid " + this.getResources().getColor(Colors.color_5),
            height:"auto",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "150px",
            marginBottom: "150px",
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_5),
            flex: 0.68,
            justifyContent: "left",
            textAlign: "left",
            marginTop: "40px",
            marginBottom: "40px",
            width: '100%',
            padding: '0px 20px'
        };
    }

    getTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "left",
            // height: "40px",
            width: '300px',
            fontWeight: "bold",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_36),
            lineHeight: "40px",
            fontFamily:this.getResources().getFontFamily(),

        };
    }
    

    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
        };
    }
    getRequestOTPButtonCSSStyle(): object 
    {
        return {
            marginTop: "50px",
            width:'180px'
        };
    }

   
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpcss.tsx